(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westerne-journal-shop"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('header-drawer a');
    if (!link) return;
    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;
    if (!['#westerne-journal', '#westerne-shop'].includes(destination.hash)) return;
    link.closest('header-drawer').querySelector('.menu-drawer__close-button')?.click();
  });

  } catch(e) { console.error(e); }
})();
})();
